import "./sidenav.component.scoped.sass";
import React, { useContext } from "react";
import { ProfileIconComponent } from "../profile-icon/profile-icon.component";
import { SideNavItemsComponent } from "../sidenav-items/sidenav-items.component";
import { GlobalContext } from "src/store";
import { PaymentNavComponent } from "../payment-nav/payment-nav.component";

export const SideNavComponent = () => {
  const { paymentNav } = useContext(GlobalContext);
  return (
    <div className={`main-nav ${paymentNav ? 'payment' : ''}`}>
      <div className="sidenav">
        <ProfileIconComponent />
        <SideNavItemsComponent />
      </div>
      {paymentNav && (
        <div className="payment-nav">
          <PaymentNavComponent />
        </div>
      )}
    </div>
  );
};
